import { Injectable } from '@angular/core';
import {
  CountryLanguages,
  RedirectionUrl
} from '../../models/utils/country-language.interfaces';
import { CountryLanguageHelperExtended } from './country-language-helper-extended';
@Injectable({
  providedIn: 'root'
})
export class CountryLangHelperExtended extends CountryLanguageHelperExtended {
  getCookieValue(): void {
    if (this.countryLanguageList) {
      const url = window.location.host;
      const countryCode = this.getCountryCodeFromPrefCookie();

      let prefUI = 'en-us';
      this.countryLanguageList.filter((item) => {
        if (item.isoCode === countryCode && !this.languageCode) {
          this.getLangCode(item, url);
        }
      });
      if (this.languageCode) {
        prefUI = this.languageCode + '-' + countryCode;
      }
      this.deleteCookie(prefUI);
    }
  }

  getLangCode(item: CountryLanguages, url: string): void {
    const itemLang = item.languageDtls.filter((languageURL) => {
      if (languageURL.url.toLowerCase() === url) {
        return languageURL;
      }
      return null;
    });
    this.languageCode = itemLang[0].languageCode;
  }

  checkForKey(currentURl: string, search: string): boolean {
    if (currentURl.indexOf(search) > -1) {
      return true;
    } else {
      return false;
    }
  }

  getRedirectionValue(
    item: RedirectionUrl,
    currentPath: string
  ): string | null {
    let response: string | null = null;
    const searchKey = item['searchKey' as keyof RedirectionUrl];

    if (searchKey) {
      const isKey = this.checkForKey(currentPath, searchKey);
      if (isKey) {
        response = item.url;
      }
    } else {
      response = item.url;
    }
    return response;
  }

  isStopRedirection(): boolean {
    const currentPath = window.location.pathname;
    const responseValue = this.redirectionList.find((item) => {
      if (item.url.toLowerCase() === currentPath.toLowerCase()) {
        return this.getRedirectionValue(item, currentPath);
      } else {
        return null;
      }
    });
    let isKeyPresent = false;
    if (responseValue) {
      isKeyPresent = true;
    }
    return isKeyPresent;
  }

  getValidDomainName(domainHost: string): string | undefined {
    const res = domainHost.split('//');
    if (res.length > 1) {
      domainHost = res[1];
    } else {
      domainHost = res[0];
    }
    const re = new RegExp(
      /www\d*|delta|draft\d*|dvl\d*|si\d*|st\d*|qa\d*|ddwa\d*|dswa\d*|dtwa\d*|dpwa\d*|localhost|prd\d*|author\d*|publish\d*|preview\d*|\d*|.*as\d*/
    );
    const match = domainHost.match(re);
    return match?.[0] === 'www' ? '' : match?.[0];
  }

  getUrlToRedirectForCDC(): string {
    if (this.redirectionList && this.redirectionList.length > 0) {
      const currentLocationUrl = window.location.href;
      let urlToRedirect = ''; // TODO: Add proper typing
      this.redirectionList.filter((item) => {
        if (
          item.key &&
          currentLocationUrl &&
          currentLocationUrl.indexOf(item.key) !== -1
        ) {
          urlToRedirect = item.url;
        }
      });
      return urlToRedirect;
    }
    return '';
  }

  splitPrefCookies(prefCookie?: string | null): string[] | null {
    if (prefCookie && prefCookie.length > 0) {
      const res = prefCookie.split('-');
      return res;
    }
    return null;
  }

  getCountryCodeFromPrefCookie(): string | null {
    const prefCookie = this.cookieHelper.getCookieValue('prefUI');
    const res = this.splitPrefCookies(prefCookie);
    return res ? res[1].toLowerCase() : null;
  }

  getDomainName(domainHost: string): string {
    const res = domainHost.split('//');
    if (res.length > 1) {
      domainHost = res[1];
    } else {
      domainHost = res[0];
    }
    if (domainHost) {
      domainHost = domainHost.split('.')[0];
    }
    return domainHost;
  }

  getLanguageCodeFromPrefCookie(): string | null {
    const prefCookie = this.cookieHelper.getCookieValue('prefUI');
    const res = this.splitPrefCookies(prefCookie);
    return res ? res[0].toLowerCase() : null;
  }
}
